import store from "../redux-store/index";
import { updateFulfillmentStatementFn } from "facade/ServiceFacade";
import { exec, isElectron } from "utils/nativeHooks";
import { ONLINE, ARROWUP, ARROWDOWN, COD, CREATE_TICKETS, CREATE_TICKET_ON_PRINT, ZOMATO } from "utils/constants";
import { ASSIGN_NOTE, DAAS_CONSTANTS, DOTPE_SOURCE_TYPES, NW_APP_EVENT_ACTIONS, NW_APP_EVENT_KEYS, SELF_DELIVERY } from "data/constants";
import { checkCreateTicket } from "./saleHelpers";
import { notificationCurrentStatus, showStopNotificationNudge } from "redux-store/slices/NotificationsSlice";
import { printSale, printSaleTickets } from "./printHelper";
import { print } from "redux-store/slices/TableViewSlice";
import { arrayToMap } from "./catalogueHelpers";
import { apiSupportArr } from "./featureRestrictionHelper";
import { stopSound } from "utils/notificationAudio";


// Moved to @rista/core/helpers/myOrderHelpers (index.desktop.ts — web-only). Re-export only:
// nothing in this file calls it.
export { isAdvanceOrder } from "@rista/core/helpers/myOrderHelpers";

export function getTrimOrderNumber(orderNumber: string) {
  if (orderNumber)
    return orderNumber?.slice(-4);
  return "";
}



export function updateSaleVo(saleData: any) {
  let windowObj: any = window;
  return windowObj.RL.saleutil.convertSaleToVO(saleData);
}

export function parseOrderData(oldData: any, newData: any) {
  let data = { ...oldData };
  data["eventLog"] = newData.eventLog;
  data["nextAction"] = newData.nextAction;
  data["fulfillmentStatus"] = newData.fulfillmentStatus;
  data["saleStatus"] = newData.saleStatus;
  return data;
}

export function updateOrderData(orderArr: any[], updatedSale: any) {
  let index = orderArr.findIndex((order: any) => order.saleId === updatedSale.saleId);
  if (index > -1) {
    let data = parseOrderData(orderArr[index], updatedSale);
    orderArr[index] = data;
  }
  return orderArr;
}







export const isAuthenticated = () => {
  let orderData = store.getState().myOrderStore?.currentOrderData;
  let flag = orderData?.customerInfo?.authenticated || false;
  if (!flag) {
    flag = orderData?.approvalRequests?.some(
      (discount: any) => discount?.status === "Approved"
    );
  }
  return flag;
};

// Moved to @rista/core/helpers/myOrderHelpers (index.desktop.ts). The other platform keeps its
// own one-liner: it calls that app's `exec` (the ristadb bridge), which core cannot import.
export { stopDesktopNotification } from "@rista/core/helpers/myOrderHelpers";


// Moved to @rista/core/helpers/myOrderHelpers (2026-09-15, shared order card). Re-export only.
export { getParentOrderId, getOrderId } from "@rista/core/helpers/myOrderHelpers";


/**
 * 
 * @param orderData 
 * @param statuses 
 * @returns true if order fulfillment status is present in statuses
 */
export function checkfulfillmentStatus(orderData: any, statuses: string[]) {
  return statuses.some(
    (status: string) => status === orderData.fulfillmentStatus
  );
}

export function switchAmongKOTs(
  kots: any,
  action: any,
  prevKot: number
): number {
  let selectedKot = 0;
  if (kots?.length) {
    if ((action === ARROWUP || action === ARROWDOWN) && prevKot == -1) {
      selectedKot = 0;
    } else if (prevKot == kots?.length - 1) {
      if (action === ARROWDOWN) {
        selectedKot = 0;
      }
      if (action === ARROWUP) {
        selectedKot = prevKot - 1;
      }
    } else if (prevKot == 0) {
      if (action === ARROWDOWN) {
        selectedKot = prevKot + 1;
      }
      if (action === ARROWUP) {
        selectedKot = kots?.length - 1;
      }
    } else {
      if (action === ARROWDOWN) {
        selectedKot = prevKot + 1;
      }
      if (action === ARROWUP) {
        selectedKot = prevKot - 1;
      }
    }
  }
  return selectedKot;
}
// Moved to @rista/core/helpers/myOrderHelpers (2026-09-15, rider row). Re-export only.
export { getLatestRiderStatus } from "@rista/core/helpers/myOrderHelpers";

// Moved to @rista/core/helpers/myOrderHelpers (2026-09-15, rider row). Re-export only.
export { isRiderCancelled } from "@rista/core/helpers/myOrderHelpers";

// Moved to @rista/core/helpers/myOrderHelpers — `isDAASOrderSource` with the feature gate (identical
// in both apps). Re-exports only: nothing left in this file calls them.
export { checkAPISupportOrder, isDAASOrderSource } from "@rista/core/helpers/myOrderHelpers";

// Moved to @rista/core/helpers/myOrderHelpers (2026-09-15, rider row). Re-export only.
export { isRiderAssignAttempted } from "@rista/core/helpers/myOrderHelpers";

// Moved to @rista/core/helpers/myOrderHelpers (2026-09-15, rider row). Re-export only.
export { isRiderAssigned } from "@rista/core/helpers/myOrderHelpers";

// Moved to @rista/core/helpers/myOrderHelpers (2026-09-15, rider row). Re-export only.
export { isOrderDispatched } from "@rista/core/helpers/myOrderHelpers";

export { isOrderCod } from "@rista/core/helpers/myOrderHelpers";

export { isAllItemsVerified } from "@rista/core/helpers/myOrderHelpers"; // moved to core 2026-09-24 (detail's ALL VERIFIED row)

export { isZomatoOrder } from "@rista/core/helpers/myOrderHelpers"; // moved to core 2026-09-15

export { isSelfDeliveryOrder } from "@rista/core/helpers/myOrderHelpers";

export function handlePrintBill(orderData: any, callbackFn = ()=> {}) {
  let saleData = { ...orderData },
    printer = store.getState().printerStore?.defaultPrinter || {};
  saleData[CREATE_TICKETS] = checkCreateTicket(CREATE_TICKET_ON_PRINT);
  let payload = {
    dataToSend: saleData,
    callback: (res: any) => {
      callbackFn();
      if (res.code) {
        printSale(saleData, printer, 1, "", false, true);
        printSaleTickets(saleData, saleData?.tickets || [], 1);
      } else {
        printSale(res, printer);
        printSaleTickets(res, res?.tickets || [], 1);
      }
    },
  };
  store.dispatch(print(payload));
}

// Moved WHOLE to @rista/core/helpers/myOrderHelpers, pulled up by the MyOrderCard dependency
// closure — none of the three existed on mobile, and all three are pure. Re-exported so this
// file's importers are unchanged. A re-export creates no local binding, but none is needed
// here: the only callers of the two mappers lived inside getOrderFulfillmentStatus, which
// moved with them (checked, per the ledger rule about .ts/.js re-exports).
export {
  getOrderFulfillmentStatus,
  getFulfillmentMapping,
  getPickupOrderNextStatus,
  getSendData,
  isDue,
  isPaid,
  updateOrderFulfillmentStatus,
} from "@rista/core/helpers/myOrderHelpers";

// DP-8153 (release_4.0.0, merged 2026-10-05) wrote these here; they live in the core folder
// above (fulfillmentStatus.ts), where My Orders v2 reads them too. Re-exports only: nothing in
// this file calls them. Its `computeCtaInfo` is not carried: the card's CTA ladder is core's
// `myOrders/orderCard.getCtaInfo`, which took DP-8153's rules.
export {
  isSourceDeliveredForced,
  getFallbackNextAction,
  getResolvedNextAction,
  getFallbackActionDueTime,
  DEFAULT_ACCEPT_IN_SECONDS,
  DEFAULT_NEXT_ACTION_DUE_SECONDS,
} from "@rista/core/helpers/myOrderHelpers";
